import { defineStore } from 'pinia'

export const useApiStore = defineStore('apiKey', {
    state:() => ({
        apiKey: "",
        lang: ""
    }),
    getters:{
        getApiKey: function (){
            return this.apiKey
        },
        getLang: function (){
            return this.lang
        }
    },
    actions: {
        setApiKey(key){
            this.apiKey = key
        },
        setLang(language){
            this.lang = language
        }
    }
});